import { useMemo } from 'react'
import { CountryQueryFilter, MunicipalityQueryFilter, useCountriesMunicipalitiesQuery } from 'src/api/api.generated'
import useCurrentLocale from 'src/app/hooks/current-locale/use-current-locale'


export default function useCountryMunicipalityLookupQuery(text: string) {
  const { hicLanguage } = useCurrentLocale()
  const { countryFilter, municipalityFilter } = useMemo(() => {
    const countryFilter: CountryQueryFilter = {
      isoCode: { nin: ['IT'] },
      name: text ? { value: text, language: hicLanguage } : undefined,
    }
    const municipalityFilter: MunicipalityQueryFilter = {
      name: text
        ? {
          startsWith: text,
        }
        : undefined,
    }

    return { countryFilter, municipalityFilter }
  }, [text])

  return useCountriesMunicipalitiesQuery({
    variables: {
      countryFilter,
      municipalityFilter,
      limit: 10,
    },
    fetchPolicy: 'cache-first',
  })
}

export function useCountryMunicipalityFetchQuery(valueId: { countryId: string; municipalityId: string | null } | null, skip: boolean) {
  const { countryFilter, municipalityFilter } = useMemo(() => {
    if (!valueId) return { countryFilter: {}, municipalityFilter: {} }

    if (valueId.municipalityId) {
      const countryFilter: CountryQueryFilter = {
        isoCode: { eq: 'IT' },
      }
      const municipalityFilter: MunicipalityQueryFilter = {
        id: { eq: valueId.municipalityId },
      }
      return { countryFilter, municipalityFilter }
    } else {
      const countryFilter: CountryQueryFilter = {
        isoCode: { nin: ['IT'] },
        id: { eq: valueId.countryId },
      }
      const municipalityFilter: MunicipalityQueryFilter = {
        id: { eq: valueId.countryId },
      }

      return { countryFilter, municipalityFilter }
    }
  }, [valueId])

  return useCountriesMunicipalitiesQuery({
    variables: {
      countryFilter,
      municipalityFilter,
      limit: 1,
    },
    skip: skip || !valueId,
    fetchPolicy: 'cache-first',
  })
}
